import * as React from "react";
import { cn } from "../../lib/utils";

const Badge = React.forwardRef(({ className, variant = "default", ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn(
        "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold transition-all duration-200",
        // Variants
        variant === "default" && "bg-primary/20 text-primary border border-primary/40 text-[11.5px] font-medium tracking-normal",
        variant === "secondary" && "bg-surface-2 text-muted-foreground border border-border text-[11.5px] font-medium tracking-normal",
        variant === "destructive" && "bg-destructive/20 text-red-400 border border-destructive/40 text-[11.5px] font-medium tracking-normal",
        variant === "success" && "bg-[rgba(0,229,160,0.15)] text-[#00e5a0] border border-[rgba(0,229,160,0.35)] text-[11.5px] font-medium tracking-normal",
        variant === "warning" && "bg-amber-500/15 text-amber-400 border border-amber-500/30 text-[11.5px] font-medium tracking-normal",
        variant === "outline" && "border border-border-2 bg-transparent text-foreground text-[11.5px] font-medium tracking-normal",
        className
      )}
      {...props}
    />
  );
});
Badge.displayName = "Badge";

export { Badge };
